import { Component, OnInit } from '@angular/core';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { SETTINGS } from '../../core/config/common.settings';
import { PageSize } from 'src/app/core/dto/page.size';
import { Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { FleetService } from '../../core/services/fleet.service';
import { Pagination } from '../../core/dto/pagination';
import * as _ from 'lodash';
import { NzMessageService } from 'ng-zorro-antd/message';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-fleet',
  templateUrl: './fleet.component.html',
  styleUrls: ['./fleet.component.scss'],
})
export class FleetComponent implements OnInit {
  breadcrumbs = [
    {
      title: 'Fleet',
      icon: 'car',
    },
  ];

  skeletonTableColumns: any[] = [
    'Vehicle ID',
    'Type',
    'Brand',
    'Model',
    'Reg No',
    'Return Date and Time',
    'Current Fuel %',
    'Current Mileage Km',
    'Next Service on Km',
    'Service Due',
    'Next T-Oil change on Km',
    'T-Oil Change Due Km',
    'Wash Status',
    'Availability',
    'Created Date',
    'Actions',
  ];
  loading = false;

  // Define variables for filter and table data
  filterAvailabilityStatus: any;
  filterWashStatus: any;
  filterActiveStatus = true;
  filterServiceDueStatus: any;
  filterOilChangeDueStatus: any;
  dateRangesCreated: any[] = [];
  startDateCreated: any;
  endDateCreated: any;
  searchText: any;
  // ranges: any;
  washStatus = SETTINGS.WASH_STATUS;
  washStatusPairs = SETTINGS.WASH_STATUS_PAIRS;
  availabilityStatus = SETTINGS.AVAILABILITY_STATUS;
  filterAvailabilityStatusPairs = SETTINGS.AVAILABILITY_STATUS_PAIRS;
  availabilityStatusPairs = [
    { value: 'AVAILABLE', label: 'Available' },
    { value: 'OUT_OF_SERVICE', label: 'Out of Service' },
  ];

  isDeleting = false;
  fleetData: any[] = []; // Initialize with dummy data

  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;

  department: any = '';
  selectedFleetId: any;

  isVisibleModal = false;
  changingAvailabilityStatus = '';

  constructor(
    private router: Router,
    private notificationService: NzNotificationService,
    private fleetService: FleetService,
    private message: NzMessageService,
  ) {}

  // Add more variables for filter options and service data as needed

  ngOnInit() {
    // emitDistinctChangesOnlyDefaultValue;
    this.getPagedFleets();
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedFleets();
  }

  goto(id?: any, type?: any): void {
    switch (type) {
      case 'update':
        if (id) {
          this.router.navigate([
            `/admin/fleets/add-edit/${id}`,
            { backLoc: 'table' },
          ]);
        } else {
          this.router.navigate(['/admin/fleets/add-edit']);
        }
        break;
      case 'view':
        this.router.navigate([`/admin/fleets/${id}`]);
        break;
      case 'service':
        this.router.navigate([
          `admin/fleets/${id}`,
          { pageName: 'fleetService' },
        ]);
        break;
      case 'repair':
        this.router.navigate([
          `/admin/fleets/${id}`,
          { pageName: 'fleetRepairs' },
        ]);
        break;
    }
  }

  getPagedFleets(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        department: this.department,
        searchText: this.searchText,
        availabilityStatus: this.filterAvailabilityStatus,
        washStatus: this.filterWashStatus,
        serviceOverdueStatus: this.filterServiceDueStatus,
        oilChangeDueStatus: this.filterOilChangeDueStatus,
        activeStatus: this.filterActiveStatus,
        createdDate: {
          start: this.startDateCreated,
          end: this.endDateCreated,
        },
        now: new Date().toISOString(),
      },
    });
    this.fleetService.getPagedFleet(payload).subscribe((res: any) => {
      this.loading = false;
      this.fleetData = res[0].data;
      this.pageSize.length = res[0].metadata[0]?.total;
    });
  }

  search(): void {
    this.getPagedFleets();
  }

  onChangeCreatedDateFilter(result: Date[]): void {
    if (result[0] && result[1]) {
      this.startDateCreated = moment(result[0]).startOf('day').format();
      this.endDateCreated = moment(result[1]).endOf('day').format();
      this.getPagedFleets();
    }
  }

  activeFilter(): void {
    this.filterActiveStatus = !this.filterActiveStatus;
    this.getPagedFleets();
  }

  resetSearch(type?: string): void {
    if (type === 'date') {
      this.startDateCreated = null;
      this.endDateCreated = null;
      this.dateRangesCreated = [];
      this.getPagedFleets();
    } else {
      this.searchText = null;
      this.filterAvailabilityStatus = null;
      this.filterActiveStatus = true;
      this.filterWashStatus = null;
      this.filterServiceDueStatus = null;
      this.filterOilChangeDueStatus = null;
      this.startDateCreated = null;
      this.endDateCreated = null;
      this.dateRangesCreated = [];
      // this.ranges = null;
      this.getPagedFleets();
    }
  }

  sort(): void {
    this.sortOrder = this.sortOrder === 1 ? -1 : 1;
    this.getPagedFleets();
  }

  changeAvailabilityStatus(st: string, id: any): void {
    this.selectedFleetId = id;
    this.changingAvailabilityStatus = st;
    this.isVisibleModal = true;
    this.fleetService.selectedFleet.next(id);
  }

  changeWashStatus(st: string, id: any): void {
    this.fleetService
      .updateFleet({
        _id: id,
        washStatus: st,
        updateType: 'wash_change',
      })
      .then(() => {
        this.message.create('success', `Vehicle wash status has been changed!`);
        this.getPagedFleets();
      });
  }

  deleteFleet(id: any): void {
    this.fleetService.deleteFleet(id).then(() => {
      this.getPagedFleets();
    });
  }

  // Update fuel and mileage modal stuff
  onGetUpdateFuelAndMileage(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.isVisibleModal = false;
        break;
      case 'done':
        this.fleetService
          .updateFleet({
            _id: this.selectedFleetId,
            availabilityStatus: this.changingAvailabilityStatus,
            updateType: 'availability_change',
          })
          .then((res) => {
            this.message.create(
              'success',
              `Vehicle availability has been changed!`,
            );
            this.getPagedFleets();
          });
        this.isVisibleModal = false;
        break;
    }
  }

  cancel(): void {
    console.log('cancel clicked');
  }

  hasPermission(perm: string): boolean {
    return _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), perm);
  }

  getBookingDateAndTime(data: any, type: string): any {
    if (type === 'upcoming') {
      const bookings: any[] = data;
      bookings?.sort(
        (a, b) => a?.bookingStartDateAndTime - b?.bookingStartDateAndTime,
      );
      return bookings[0]?.bookingStartDateAndTime;
    }

    if (type === 'ongoing') {
      const bookings: any[] = data;
      bookings?.sort(
        (a, b) => b?.bookingEndDateAndTime - a?.bookingEndDateAndTime,
      );
      return bookings[0]?.bookingEndDateAndTime;
    }
  }

  // Define functions for getting filter options, retrieving fleet data, and handling actions

  // Implement the functions to get filter options, retrieve fleet data, and handle actions

  // You can follow the structure of the UsersComponent for these functions
}
